import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Tooltip } from "antd";
import Tag from "../../general/antd/tag";
import { IOrderTrip } from "../../../models/order/response";
import { getTripStatusColor, getTripStatusLabel } from "../../../utils/helpers/trip-helpers";
import styles from "./style.module.scss";

interface ITripBadgeProps {
  trip?: IOrderTrip | null;
}

const TripBadge: React.FC<ITripBadgeProps> = ({ trip }) => {
  const { t } = useTranslation();

  // The order never entered a trip - a legitimate state, not an error.
  if (!trip) {
    return <Tag title={t("no_trip")} color="default" />;
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}>
      <Link to={`/trips/details/${trip.id}`} className={styles.tripLink}>
        <Tag title={trip.number || `#${trip.id}`} color={getTripStatusColor(trip.status)} />
      </Link>
      <span style={{ fontSize: "11px", color: "#666" }}>
        {t(getTripStatusLabel(trip.status))}
      </span>
      {/* Withdrawn means this trip did not deliver the order, which the trip
          status alone does not convey - an order pulled out of a live trip
          would otherwise just read "active trip". */}
      {trip.removedAt && (
        <Tooltip title={trip.removalReason || undefined}>
          <span>
            <Tag title={t("removed_from_trip")} color="volcano" />
          </span>
        </Tooltip>
      )}
    </div>
  );
};

export default TripBadge;
